export const INVESTIGATOR_AUDITOR = "auditor";
export const INVESTIGATOR_CO_AUDITOR = "coAuditor";
